export default __webpack_public_path__ + "static/us_consumer_pa_modal_gift_1-df718773337395ea56c8be1f17d147f7.png";